<p-overlayPanel [baseZIndex]="50" [appendTo]="body" #popover id="popover" styleClass="popover" (onShow)="refresh()">

	<ng-content></ng-content>

	<div class="filtre">
		<input #filtreRef [(ngModel)]="filtre" [appAutofocus]="init" name="filtre" id="filtre" [placeholder]="'SIGALE_ANGULAR.COMPONENTS.POPOVER.FILTRE_LABEL' | translate"/>
		<i class="fa fa-search" [hidden]="filtre"></i>
		<i class="fas fa-times annuler" [hidden]="!filtre" (click)="clearFilter()"></i>
	</div>

	<div class="panel">
		<div *ngIf="selectionMultipleInterne">
			<div>
				<input class="selection"
					   type="checkbox"
					   id="selectAll"
					   [(ngModel)]="selectAll"
					   (change)="selectDeselectAll($event)"/>
				<label for="selectAll">{{ 'SIGALE_ANGULAR.COMPONENTS.POPOVER.CHECKBOX_SELECTIONNER_TOUT' | translate }}</label>
			</div>
			<hr>
			<div *ngFor="let donnee of donneesInterne; let i=index" [hidden]="donnee.hide" class="selection">
				<input class="selection"
					   type="checkbox"
					   [(ngModel)]="donnee.selected"
					   [id]="'donnee' + i" [name]="'donnee' + i"
					   (change)="toggleDonnee($event, donnee)"/>
				<label [for]="'donnee' + i" [title]="formatter(donnee)">{{ formatter(donnee) }}</label>
			</div>
		</div>
		<div *ngIf="!selectionMultipleInterne">
			<div *ngFor="let donnee of donneesInterne; let i=index" [hidden]="donnee.hide" class="selection">
				<input class="selection"
					   type="radio"
					   [id]="'donnee' + i"
					   name="donnee"
					   [value]="donnee"
					   [(ngModel)]="selectionsInterne[0]"
					   (click)="toggleDonnee($event, donnee)"
					   [title]="formatter(donnee)"><label [for]="'donnee' + i" [title]="formatter(donnee)">{{ formatter(donnee) }}</label>
			</div>
		</div>
	</div>

	<div class="footer">
		<button type="button" class="btn btn-primary btn-md button" (click)="handleValidation($event)">{{ 'SIGALE_ANGULAR.COMPONENTS.POPOVER.BOUTON_VALIDATION' | translate }}</button>
		<button type="button" class="btn btn-link" (click)="handleAnnulation($event)">{{ 'SIGALE_ANGULAR.COMPONENTS.POPOVER.BOUTON_ANNULATION' | translate }}</button>
	</div>
</p-overlayPanel>
